module.exports = __webpack_public_path__ + "img/马钱子.a9e46fc0.jpg";